/* Đơn vị (công ty) đang làm việc – chỉ giữ trạng thái, không phụ thuộc phần dữ liệu để tránh vòng nhập. */
import { useSyncExternalStore } from 'react';

const KEY = 'ct_co';
let current = 'main';
try { current = localStorage.getItem(KEY) || 'main'; } catch { /* trình duyệt chặn lưu: dùng đơn vị chính */ }
const subs = new Set<() => void>();

export const getCompany = (): string => current;

export function setCompanyRaw(id: string): void {
  if (id === current) return;
  current = id;
  try { localStorage.setItem(KEY, id); } catch { /* bỏ qua */ }
  subs.forEach(f => f());
}

export const useCompanyId = (): string => useSyncExternalStore(f => { subs.add(f); return () => { subs.delete(f); }; }, getCompany);
